import React from "react";
import Button from "./layout/button";
import Icon from "./layout/icon";
import Bets from "./bets";

import "../styles/cart.scss";
import { hasLogin, hasPixParam, hasPreTicketParam, hasWalletParam } from "../../utils/getPreTickets";
import { R$ } from "../utils/brl";
import { emitIntent } from "../../newDesign/utils/emitIntent";

export default class Cart extends React.Component {
  constructor(props) {
    super(props);

    /**
     * @type {{
     *  open: boolean
     * }}
     */
    this.state = {
      open: false,
      hasWalletParam: false,
      hasPreTicketParam: false,
      hasPixParam: false,
      hasLogin: false
    };

    this.setState({ hasPreTicketParam: hasPreTicketParam() });
    this.setState({ hasPixParam: hasPixParam() });
    this.setState({ hasWalletParam: hasWalletParam() });
    this.setState({ hasLogin: hasLogin() });
  }

  render() {
    /**
     * @type {{
     *  cart: {
     *      number: number,
     *      amount: number,
     *      value: number
     *  }[],
     *  onSubtract: (number: number) => void,
     *  onClear: () => void,
     *  onConfirm: () => void,
     *  mobile?: boolean,
     *  numberLength?: number,
     *  loading?: boolean
     * }}
     */
    const {
      cart,
      onSubtract,
      onConfirm,
      onClear,
      mobile: isMobile,
      numberLength,
      loading = false,
    } = this.props;
    const { open: isCartOpen } = this.state;

    const totalValue = cart.reduce(
      (sum, bet) => sum + bet.value * bet.amount,
      0
    );

    const authenticated = hasLogin();

    const validateWithLogin = () => {
      if (authenticated) {
        onConfirm(false, true);
      } else {
        emitIntent("open_login");
      }
    }

    const minimumQuotas = Math.max(1, this.props.minimumAvailableQuotas || 1);

    const fragments = {
      summary: () => {
        return (
          <footer className="cart-rifa__footer">
            <div className="cart-rifa__summary">
              <div className="price">{`Valor Total ${R$(totalValue)}`}</div>
              <div className="rifa-cart-button-container">
                {(totalValue > 0 && hasWalletParam() && cart.length >= minimumQuotas) &&
                  <button
                    className="button submit-button rifa-due__submit-button"
                    onClick={() => { onConfirm(false, false) }}
                  >
                    Finalizar compra
                  </button>
                }
                {(hasPixParam() && totalValue > 0 && cart.length >= minimumQuotas) &&
                  <button
                    className="button submit-button rifa-due__submit-button"
                    onClick={() => validateWithLogin(false, true)}
                  >
                    Pagar Agora!
                  </button>
                }
              </div>
            </div>
          </footer>
        );
      },
      toggleButton: () => {
        return (
          <div className="cart-rifa__toggle" onClick={() => this.toggleCart()}>
            <div className="cart-rifa__toggle__button">
              {isCartOpen ? "Ocultar carrinho" : "Exibir carrinho"}
              <Icon
                type={isCartOpen ? "chevron-down" : "chevron-up"}
                color="white"
              />
            </div>
          </div>
        );
      },
    };

    return isMobile ? (
      <React.Fragment>
        <section className="cart-rifa--mobile">
          {fragments.toggleButton()}
          {isCartOpen ? (
            <div className="cart-rifa__content">
              {!!cart.length && (
                <Button
                  outlined
                  onClick={() => onClear()}
                  disabled={!cart.length}
                >
                  Limpar carrinho
                </Button>
              )}
              <Bets
                cart={cart}
                onSubtract={(number) => onSubtract(number)}
                numberLength={numberLength}
              />
            </div>
          ) : null}
          {fragments.summary()}
        </section>
      </React.Fragment>
    ) : (
      <React.Fragment>
        <section className="cart-rifa">
          <div className="cart-rifa__content">
            <header className="cart-rifa__text">
              <p className="cart-rifa__text__title rifa-title">Carrinho</p>
              <div className="cart-rifa__text__subtitle_div">
                <p className="cart-rifa__text__subtitle">
                  Números selecionados
                </p>

                <Button
                  outlined
                  onClick={() => onClear()}
                  disabled={!cart.length}
                >
                  Limpar carrinho
                </Button>
              </div>
            </header>
            <Bets
              cart={cart}
              onSubtract={(number) => onSubtract(number)}
              numberLength={numberLength}
            />
          </div>
          {fragments.summary()}
        </section>

      </React.Fragment>
    );
  }

  componentDidMount() {
    /**
     * @param {string} selector
     */
    const forceVisibleOverflow = (selector) => {
      var element = document.querySelector(selector);

      if (element) {
        var parent = element.parentElement;
        while (parent) {
          var overflow = getComputedStyle(parent).overflow;
          if (overflow !== "visible") {
            //parent.style.overflow = "visible";
          }
          parent = parent.parentElement;
        }
      }
    };

    forceVisibleOverflow(".cart-rifa");
    forceVisibleOverflow(".cart-rifa--mobile");
  }

  toggleCart() {
    this.setState({
      ...this.state,
      open: !this.state.open,
    });
  }
}



// WEBPACK FOOTER //
// ./src/rifa/components/cart.jsx